import { nanoid } from 'nanoid'

const makeUserEventRequirement = (kind = '', attr = {}, item = {}) => {
  return {
    id: nanoid(),
    kind: kind,
    attr,
    item: {
      category: null,
      categoryId: null,
      subcategory: null,
      subCategoryId: null,
      ...item
    },
    qty: 1
  }
}

export const getUserEventRequirements = challengeData => {
  const requirements = []

  if (challengeData.requirements) {
    if (challengeData.requirements.color) {
      challengeData.requirements.color.forEach(color => {
        requirements.push(
          makeUserEventRequirement('color', { color: color.toLowerCase() })
        )
      })
    }

    if (challengeData.requirements.brand) {
      challengeData.requirements.brand.forEach(brand => {
        requirements.push(
          makeUserEventRequirement('brand', {
            storeId: brand.indixStoreId,
            store: brand.storeName
          })
        )
      })
    }

    if (challengeData.requirements.category) {
      challengeData.requirements.category.forEach(category => {
        requirements.push(
          makeUserEventRequirement(
            'category',
            {},
            {
              category: category.name,
              categoryId: category.value || category.Id
            }
          )
        )
      })
    }
  }

  return requirements
}
